// extracted by mini-css-extract-plugin
export default {"SetCommissionPop":"SetCommissionPop_SetCommissionPop__kUGiL","modalBody":"SetCommissionPop_modalBody__0qf3b"};